
import {guestReservationsService} from "@/services/guest/reservations/reservations.service";
import {alertService} from "@/services/alert/alert.service";
export default {
    data() {
        return {
            data: {
                entry_date: '',
                entry_time: '',
                exit_date: '',
                exit_time: '',
                parking_fee: '',
            },
            dataReady: false,
        }
    },
    filters: {
        numberFormat: function (value) {
            if (!value || value == 0) return 0;
            value = value.toString();
            return value.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        },
    },
    methods: {
        async getFee$(){
            var callback = async () => {
                this.dataReady = false;
                await alertService.loading();
                await guestReservationsService.fee({
                    parking_id: 1,
                    entry_date: this.data.entry_date,
                    entry_time: this.data.entry_time,
                    exit_date: this.data.exit_date,
                    exit_time: this.data.exit_time,
                    region: '仙台',
                    registered_number: '1234',
                    hiragana: 'あ',
                    sort_number: '330',
                })
                .then((response) => {
                    this.dataReady = true;
                    this.data.parking_fee = response.data.parking_fee;
                    alertService.close();
                }).catch((error) => {
                    console.log(error);
                    alertService.error(this.$t('facility.global.error'), this.$t('facility.calc-fee.failure'));
                });
            }
            callback();
        }
    }

}
